jQuery(document).ready(function () {
	// Pattern: Accordion
	var accordion = (function () {
		// Expand/collapse accordion item.
		function accordionToggle() {
			var parentAccordion = jQuery(this).closest(".pattern-accordion");
			var numItems = parentAccordion.find(".accordion__item").length;
			var expandAll = jQuery(parentAccordion).find(".accordion__expand-all");
			var collapseAll = jQuery(parentAccordion).find(
				".accordion__collapse-all",
			);

			if (jQuery(this).hasClass("js-expanded")) {
				var accordionItem = jQuery(this)
					.attr("aria-expanded", "false")
					.removeClass("js-expanded")
					.parent()
					.parent()
					.next(".accordion__content");
				var accordionWrapper = jQuery(this)
					.parent()
					.parent()
					.parent()
					.attr("aria-expanded", "false");

				accordionItem.removeClass("accordion-item-open");
				accordionItem.delay(150).slideUp(150);
			} else {
				if (jQuery(this).hasClass("accordion__toggle--exclusive")) {
					accordionCollapseAll(
						event,
						jQuery(this)
							.parent()
							.parent()
							.parent()
							.siblings(".accordion__item"),
					);
				}

				var accordionItem = jQuery(this)
					.attr("aria-expanded", "true")
					.addClass("js-expanded")
					.parent()
					.parent()
					.next(".accordion__content");
				var accordionWrapper = jQuery(this)
					.parent()
					.parent()
					.parent()
					.attr("aria-expanded", "true");

				accordionItem.slideDown(150);
				accordionItem.addClass("accordion-item-open");
			}

			var openItems = parentAccordion.find(".js-expanded").length;

			if (openItems > 0) {
				collapseAll
					.removeClass("js-disabled")
					.removeAttr("diabled")
					.removeAttr("aria-expanded")
					.prop("disabled", false);
			} else {
				collapseAll
					.addClass("js-disabled")
					.attr("disabled", "")
					.attr("aria-expanded", "true")
					.prop("disabled", true);
			}

			if (openItems < numItems) {
				expandAll
					.removeClass("js-disabled")
					.removeAttr("disabled")
					.removeAttr("aria-expanded")
					.prop("disabled", false);
			} else {
				expandAll
					.addClass("js-disabled")
					.attr("disabled", "")
					.attr("aria-expanded", "true")
					.prop("disabled", true);
			}
		} // Expand-all toggle functionality.

		function accordionExpandAll() {
			var accordionItems = jQuery(this).parent().siblings(".accordion__item");
			jQuery(accordionItems)
				.find(".accordion__toggle")
				.attr("aria-expanded", "true");
			jQuery(accordionItems).find(".accordion__toggle").addClass("js-expanded");
			jQuery(accordionItems).find(".accordion__content").addClass("visible");
			jQuery(accordionItems).find(".accordion__content").slideDown(300);
			jQuery(this)
				.addClass("js-disabled")
				.attr("aria-expanded", "true")
				.find("button")
				.prop("disabled", true);
			jQuery(this)
				.siblings(".accordion__collapse-all")
				.removeClass("js-disabled")
				.removeAttr("aria-expanded")
				.find("button")
				.prop("disabled", false);
		} // Collapse-all toggle functionality.

		function accordionCollapseAll(
			event,
			accordionItems = jQuery(this).parent().siblings(".accordion__item"),
		) {
			jQuery(accordionItems)
				.find(".accordion__toggle")
				.attr("aria-expanded", "false");
			jQuery(accordionItems)
				.find(".accordion__toggle")
				.removeClass("js-expanded")
				.attr("aria-expanded", "false");
			jQuery(accordionItems)
				.find(".accordion__content")
				.slideUp(300)
				.prop("disabled", true);
			jQuery(this)
				.addClass("js-disabled")
				.attr("aria-expanded", "false")
				.find("button")
				.prop("disabled", true);
			jQuery(this)
				.siblings(".accordion__expand-all")
				.removeClass("js-disabled")
				.removeAttr("aria-expanded")
				.find("button")
				.prop("disabled", false);
		} // Accordion item back-to-top functionality.

		function accordionBackTop() {
			var headerHeight = jQuery("header")
				.children(".site-header")
				.children(".header-bar")
				.outerHeight(true);
			var accordionTop = jQuery(this)
				.closest(".pattern-accordion")
				.find(".accordion__all");

			jQuery("html, body").animate(
				{
					scrollTop: accordionTop.offset().top - headerHeight,
				},
				300,
			);

			if (accordionTop.find(".accordion__expand-all").hasClass("js-disabled")) {
				accordionTop
					.find(".accordion__collapse-all")
					.children("button")
					.focus();
			} else {
				accordionTop.find(".accordion__expand-all").children("button").focus();
			}
		}

		var init = function init() {
			if (!jQuery(".pattern-accordion.spcc-site-menu").length) {
				return;
			}
			const menus = jQuery(".pattern-accordion.spcc-site-menu");
			for (menu of menus) {
				jQuery(menu).find(".accordion__toggle").on("click", accordionToggle);
			}
		};
		return {
			init: init,
		};
	})();

	accordion.init();
});
